import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowLeft} = FiIcons;

const TermsPage = () => (
  <div className="min-h-screen bg-gradient-to-b from-slate-50 to-stone-100 py-16 px-4 sm:px-6 lg:px-8">
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{opacity: 0, y: 30}}
        animate={{opacity: 1, y: 0}}
        transition={{duration: 0.8}}
      >
        <Link
          to="/"
          className="inline-flex items-center text-amber-700 hover:text-amber-800 mb-8 transition-colors"
        >
          <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
          Zurück zur Startseite
        </Link>

        <div className="bg-gradient-to-r from-stone-50 to-slate-50 px-6 py-8 rounded-t-2xl border border-stone-200">
          <h1 className="text-4xl font-bold text-stone-800">
            Allgemeine Geschäftsbedingungen
          </h1>
        </div>

        <div className="bg-white p-12 rounded-b-2xl shadow-lg border-l border-r border-b border-stone-200">
          <div
            className="prose prose-stone max-w-none space-y-8 text-stone-700"
            style={{fontFamily: 'Lato, sans-serif'}}
          >
            <h2
              className="text-2xl font-serif text-stone-800 border-b border-stone-100 pb-2"
              style={{fontFamily: 'Libre Baskerville, serif'}}
            >
              Allgemeine Geschäftsbedingungen von Yin und Klang
            </h2>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Geltungsbereich
              </h3>
              <p>
                Diese AGB gelten für alle Kurs- und Retreatangebote von Yin und Klang
                sowie für den Kauf und die Einlösung von Gutscheinen, unabhängig davon,
                ob die Buchung über die Webseite, per E-Mail oder auf anderem Weg erfolgt.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Vertragsabschluss
              </h3>
              <p>
                Die Darstellung der Angebote, der unterschiedlichen Formate stellt kein
                bindendes Angebot dar. Mit dem Absenden des Formulars wird lediglich eine
                Anfrage gestellt. Der Vertrag kommt erst zustande, wenn Yin und Klang die
                Teilnahme in Textform bestätigt und die Teilnahmegebühr vollständig
                eingegangen ist.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Platzsicherung und Zahlung
              </h3>
              <p>
                Die Teilnahmegebühr ist innerhalb von 5 Tagen nach Rechnungsstellung zu
                zahlen. Maßgeblich für die Platzsicherung ist der tatsächliche
                Zahlungseingang. Erfolgt keine fristgerechte Zahlung, kann der Platz ohne
                weitere Mitteilung anderweitig vergeben werden.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Leistungen
              </h3>
              <p>
                Inhalt, Umfang und Termine ergeben sich aus der jeweiligen
                Angebotsbeschreibung. Änderungen aus wichtigem Grund bleiben vorbehalten.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Stornobedingungen
              </h3>
              <p className="mb-2 text-stone-800 font-medium">
                Stornierungen müssen in Textform erfolgen:
              </p>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>
                  bis 21 Tage vor Beginn: vollständige Rückerstattung der gezahlten
                  Teilnahmegebühr
                </li>
                <li>
                  20 bis 8 Tage vor Beginn: 50 Prozent der Teilnahmegebühr werden
                  einbehalten, 50 Prozent werden erstattet
                </li>
                <li>
                  ab 7 Tage vor Beginn oder bei Nichterscheinen: vollständiger Einbehalt
                  der Teilnahmegebühr
                </li>
              </ul>
              <p className="mt-3">
                Die Stornokosten entfallen, wenn eine Ersatzperson gestellt wird oder der
                Platz durch Yin und Klang neu besetzt werden kann. Eine einmalige
                Umbuchung ist bis 7 Tage vor Beginn möglich.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Gutscheine (online und in Papier)
              </h3>
              <div className="space-y-4">
                <p>
                  Über das Kontaktformular oder per E-Mail können für unsere Formate
                  Gutscheine angefragt werden. Wir senden eine Rechnung. Nach der
                  vollständigen Bezahlung versenden wir den Onlinegutschein per Mail bzw.
                  den Papiergutschein per Post.
                </p>
                <p>
                  Für den Kauf eines Gutscheins gilt das gesetzliche{' '}
                  <a
                    href="https://yin-und-klang.de/widerrufsbelehrung"
                    className="text-amber-700 hover:text-amber-800 hover:underline"
                  >
                    Widerrufsrecht
                  </a>
                  .
                </p>
                <p>
                  Der Gutschein ist gültig gemäß der gesetzlichen Verjährungsfrist: 3
                  Jahre ab Ende des Ausstellungsjahres. Er gilt für das darauf genannte
                  Format, auch wenn sich der Preis zwischenzeitlich ändert. Wird ein
                  Format nicht mehr angeboten, kann der Gutschein für ein gleichwertiges
                  Angebot eingelöst werden. Der Gutschein ist frei übertragbar und wird
                  nicht in bar ausgezahlt. Bei Verlust kann kein Ersatz geleistet werden.
                </p>
                <p>
                  Die Einlösung erfolgt nach Terminvereinbarung und ist an die
                  Verfügbarkeit freier Plätze gebunden. Ein Anspruch auf einen bestimmten
                  Termin besteht nicht. Der Gutschein ist bei der Terminvereinbarung
                  anzugeben und zum Termin vorzulegen.
                </p>
              </div>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Durchführung
              </h3>
              <p>
                Die Angebote finden unabhängig von einer Mindestteilnehmerzahl statt.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Eigenverantwortung
              </h3>
              <p>
                Die Teilnahme erfolgt auf eigene Verantwortung und ersetzt keine
                medizinische oder therapeutische Behandlung.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Haftung
              </h3>
              <p>
                Die Haftung ist auf Vorsatz und grobe Fahrlässigkeit beschränkt. Bei
                einfacher Fahrlässigkeit nur bei Verletzung wesentlicher Vertragspflichten.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Datenschutz
              </h3>
              <p>
                Personenbezogene Daten werden ausschließlich zur Vertragsdurchführung
                genutzt.
              </p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-stone-800 mb-2">
                Schlussbestimmungen
              </h3>
              <p>Es gilt deutsches Recht.</p>
            </section>
          </div>
        </div>
      </motion.div>
    </div>
  </div>
);

export default TermsPage;